import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

const updateTaskItems = async ({ updates }) => {
  console.log('[UpdateItems] called with updates: ', updates)

  const url = `${baseUrl}/aws/tasks/updateitems`

  try {
    const response = await axios.put(url, { updates })

    if (response.status !== 200) throw new Error('Network response was not ok')

    return response.data
  } catch (error) {
    console.error('Failed to update items:', error)
    throw error
  }
}

export const useUpdateTaskItems = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: updateTaskItems,
    onSuccess: (data, variables) => {
      console.log('[useUpdateItems] Updated items data:', data, 'VARIABLES: ', variables)
      // Invalidate tasks_table to update the grid's progress calculations
      queryClient.invalidateQueries({ queryKey: ['tasks_table'] })
      variables.updates.forEach(update => {
        const orgId = update?.pkValue?.replace('ORG_', '')
        console.log('[useUpdateTaskItems] Invalidating queries for orgId:', orgId)
        // Invalidate the correct query keys used by MTB drawer
        queryClient.invalidateQueries({ queryKey: ['ensureMonthlyTasks', orgId] })
        queryClient.invalidateQueries({ queryKey: ['tasksByOrgId', orgId, {}] })
        queryClient.invalidateQueries({ queryKey: ['orgMonthlyProgress', orgId] })
      })
    },
    onError: error => {
      console.log('error', error)
      console.error('[useUpdateItems] Error updating items:', error)
    },
    onSettled: (_, __) => {
      console.log('on settled')
    },
  })

  return mutation
}
